import { createFileRoute } from "@tanstack/react-router";
import { textParam } from "@/utils/searchParams";

// The wizard step lives in the URL,
// so browser back/forward walk the flow and steps deep-link.
export const WIZARD_STEPS = [
  "landing",
  "search",
  "finder",
  "url-input",
  // Shown only when the extraction found more than one product on the page
  // (PRD C3a); a single-product page goes straight to the form.
  "url-products",
  // Where every proposal is completed and sent, whether it names one product
  // or several — so the button at the bottom of it is the only thing that
  // raises a request, and nothing before it claims to (Jira NAV-121).
  "form",
  "submitted",
] as const;

export type WizardStep = (typeof WIZARD_STEPS)[number];

export type RequestAccessSearch = {
  step?: WizardStep;
  // The search step's term rides along for NAV-45: opening a result and coming
  // back used to land on the right step with an empty box. Each step writes its
  // own search object, so moving off the search step drops it.
  q?: string;
};

export const Route = createFileRoute("/end-user/request-access")({
  validateSearch: (search: Record<string, unknown>): RequestAccessSearch => ({
    step: WIZARD_STEPS.includes(search.step as WizardStep)
      ? (search.step as WizardStep)
      : undefined,
    q: textParam(search.q),
  }),
});
